import {
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableHeader,
    TableRow,
} from '@ksyos/design-system';
import type { Uuid } from '@common/utils/uuid';
import type { FundingServicePart } from '@frontend/services/api/fundingServicePartsApiService';
import { getLanguage } from '@common/translate/translate';
import type { FundableServiceActivity } from './FundingServiceParts';

export type FundingServicePartsListProps = {
    canEdit: boolean;
    onEdit: (id: Uuid) => void;
    onRemove: (id: Uuid) => void;
    parts: FundingServicePart[];
    serviceActivities: FundableServiceActivity[];
};

export function FundingServicePartsList({
    canEdit,
    onEdit,
    onRemove,
    parts,
    serviceActivities,
}: FundingServicePartsListProps) {
    const translate = getLanguage();

    const sortedParts = [...parts].sort((a, b) => a.name.localeCompare(b.name));

    return (
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableHeader>{translate.common.name}</TableHeader>
                        <TableHeader>{translate.finance.fundingServicePart.activities}</TableHeader>
                        {canEdit && <TableHeader>{translate.common.edit}</TableHeader>}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {sortedParts.map((part) => (
                        <TableRow key={part.id}>
                            <TableCell>{part.name}</TableCell>
                            <TableCell>{part.fundingForActivityCodes.map(mapActivityCodeToName).join(', ')}</TableCell>
                            {canEdit && (
                                <TableCell>
                                    <IconButton
                                        icon="edit"
                                        labelText="Edit"
                                        onClick={() => onEdit(part.id)}
                                    />
                                    <IconButton
                                        icon="delete"
                                        onClick={() => onRemove(part.id)}
                                    />
                                </TableCell>
                            )}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );

    function mapActivityCodeToName(activityCode: string) {
        return serviceActivities.find((a) => a.code === activityCode)?.name ?? 'onbekend';
    }
}
